import { trackEvent } from '@finn-no/pulse-sdk';

export default {
    callable: (element: HTMLElement) => {
        const eventElement = document.getElementById("pulse-event")?.textContent;
        if (!eventElement) {
            console.error('Pulse click tracking: Could not find #pulse-event element within', element);
            return;
        }

        try {
            const baseEvent = JSON.parse(eventElement);
            // Ensure baseEvent is not empty or null before proceeding
            if (!baseEvent || Object.keys(baseEvent).length === 0) {
                console.error('Pulse click tracking: Parsed event data is empty or invalid.', element);
                return;
            }

            const event = {
                ...baseEvent,
                type: "Click", // Override or set the type to Click
            };

            // Options match the original attempt in the diff
            trackEvent(event, { disableAddPageContext: true, resolveOnQueued: false });

        } catch (e) {
            console.error('Pulse click tracking: Failed to parse JSON from #pulse-event', eventElement, e);
        }
    },
};
